import React, { useState, useMemo, useEffect } from 'react';
import ModalContentBase from '../redux/components/modal/modal_content_base';

const INFO_URL = 'https://tunagate.com/articles/faq/make-events/cd0403c3';

const SectionMutualRecruiting = ({ event, setEvent, mutualConditionsError = '', isVip, creatorTrialRemaining, }) => {
  const canUseMutual = isVip || (creatorTrialRemaining ?? 2) > 0;
  const [showPullDown, setShowPullDown] = useState(
    (!!event.is_mutual_recruiting || !!event.mutual_recruiting_description) && canUseMutual
  );

  // 残り回数が0 or 非VIP になったら、強制的にOFFにする
  useEffect(() => {
    if (!canUseMutual && event.is_mutual_recruiting) {
      setEvent(prev => ({ ...prev, is_mutual_recruiting: false, mutual_recruiting_description: ''}));
      setShowPullDown(false);
    }
  }, [canUseMutual]);

  const previewContent = (
    <span>
      <img src="/img/question.png" className="" height="auto" style={{ width: '15px' }} />
    </span>
  );

  const modalContentAbout = (
    <div>
      <div className="modal-view-header">
        <div style={{ margin: '0 0 6px', padding: '1.5em', textAlign: 'left' }}>
          <strong>相互参加とは</strong>
        </div>
      </div>
      <div className="modal-view-body" style={{ padding: '0px 25px 50px', textAlign: 'left' }}>
        <p className="pb-3">オンにすると、あなたのイベントを見た他のイベントクリエイターから、「相互で参加したい」という申請が届きます。</p>
        <p className="pb-3">48時間以内に、申請に対して「承諾」または「却下」を選びます。承諾すると、このイベントに相手が参加する代わりに、相手のイベントにも参加することになります。却下や期限切れの申請は自動で返金されます。</p>
        <p className="pb-3">（イベント参加者が2人以上に増えるとイベント参加申し込みが増加する傾向があります。イベントの参加者数を増やしたいクリエイターさんにおすすめです。）</p>
      </div>
      <div className="modal-view-footer" />
    </div>
  );

  const modalContentCond = (
    <div>
      <div className="modal-view-header">
        <div style={{ margin: '0 0 6px', padding: '1.5em', textAlign: 'left' }}>
          <strong>相互参加が可能な条件とは</strong>
        </div>
      </div>
      <div className="modal-view-body" style={{ padding: '0px 25px 50px', textAlign: 'left' }}>
        <p className="pb-3">この欄には「この条件ならあなたのイベントにも参加できます」という基準を記入します。</p>
        <p className="pb-3">たとえばカテゴリ、開催エリア、予算上限、対象層、参加しやすい日時帯などです。</p>
        <p className="pb-3">条件が明確だと、申請が集まりやすくなり、期待値が不一致の申請を減らせます。</p>
        <p className="pb-3">内容はクリエイター"相互参加"コーナーにて表示されます。</p>
      </div>
      <div className="modal-view-footer" />
    </div>
  );

  // 3週間ルール（未入力時は許可）
  const is21DaysLater = useMemo(() => {
    if (!event.event_date) return true;
    const now = new Date();
    const dt = new Date(event.event_date);
    return (dt - now) / (1000 * 60 * 60 * 24) >= 21;
  }, [event.event_date]);

  return (
    <section id="mutual_recruiting">
      <div className="container col-md-8 col-lg-6">
        <div style={{ display: 'flex' }}>
          <p className="text-fz-14px text-fw-bold text-black-50 mb-2_5 mt-4 d-inline-block">
            相互参加を受け付ける
          </p>
          <a
            href={INFO_URL}
            target="_blank"
            rel="noreferrer"
            className="text-primary d-inline-block ml-1 mt-3-5"
            aria-label="相互参加の説明を見る"
          >
            <img src="/img/question.png" style={{ width: '15px' }} alt="" />
          </a>
        </div>
        {/* VIPでなければ残回数を表示 / VIP なら非表示 */}
        {!isVip && (
          <p className="text-gray text-fz-small mt-0 mb-1">
            無料お試し回数 残り {creatorTrialRemaining ?? 2} 回
          </p>
        )}
        <p className="text-gray text-fz-small mt-0 mb-1">
          ※開催まで21日以上先のイベントのみオンにできます。
        </p>
      </div>

      <div className="container col-md-8 col-lg-6 px-0 mt-2">
        <a
          href={INFO_URL}
          target="_blank"
          rel="noreferrer"
          className="text-primary d-inline-block"
          aria-label="相互参加の詳しい説明を見る"
        >
          <img
            src="/assets2019/mutual_recruiting_banner.png"
            alt="相互参加のご案内"
            className="w-100"
          />
        </a>
      </div>

      {/* トグル */}
      <div className="shadow-sm mb-3 bg-white">
        <div className="container col-md-8 col-lg-6 p-3_5">
          <div className="custom-control custom-switch custom-switch-md">
            <input
              type="checkbox"
              className="custom-control-input"
              id="is_mutual_recruiting"
              checked={!!event.is_mutual_recruiting}
              onChange={(e) => {
                const checked = e.target.checked;
                // 使用不可のときは反応させない
                if (!is21DaysLater || !canUseMutual) return;
                setShowPullDown(checked);
                setEvent(prev => ({
                  ...prev,
                  is_mutual_recruiting: checked,
                  ...(checked ? {} : { mutual_recruiting_description: '' }),
                }));
              }}
              disabled={!is21DaysLater || !canUseMutual}
            />
            <label className="custom-control-label" htmlFor="is_mutual_recruiting">
              相互参加の申請を許可する
            </label>
            {!is21DaysLater && (
              <p className="text-gray text-fz-small mt-2 mb-0">
                開催まで21日未満のため相互参加は利用できません。
              </p>
            )}
            {/* 非VIP かつ 残り0回の場合の誘導 */}
            {!isVip && (creatorTrialRemaining ?? 2) === 0 && (
              <p className="text-gray text-fz-small mt-2 mb-0">
                無料お試し回数を使い切りました。<a href="/memberships" target="_blank" style={{ color: '#008AEC' }}>VIPメンバー</a>になると無制限で利用できます。
              </p>
            )}
          </div>
        </div>

        {/* トグルONで下に条件入力を表示 */}
        {showPullDown && canUseMutual && (
          <div className="container col-md-8 col-lg-6 pb-3 pt-0">
            <div style={{ display: 'flex' }}>
              <p className="text-fz-14px text-fw-bold text-black-50 mb-2_5 mt-3 d-inline-block">
                相互参加が可能な条件(20文字〜40文字程度)
              </p>
              {event.is_mutual_recruiting && (
                <span className="text-fz-14px text-fw-bold text-orange mb-2 mt-3 ml-2 d-inline-block">必須</span>
              )}
              <div className="ml-1" style={{ marginTop: 12 }}>
                <ModalContentBase previewContent={previewContent} modalContent={modalContentCond} />
              </div>
            </div>

            <div className="form-group mb-0">
              <textarea
                className="form-control"
                rows="3"
                placeholder={`（例）ボードゲームで、20代が新宿で集まるイベント\n（例）飲み会イベントなら参加します。参加費、飲食代も含めて5000円に収まるイベント希望です。`}
                value={event.mutual_recruiting_description || ''}
                onChange={(e) =>
                  setEvent(prev => ({ ...prev, mutual_recruiting_description: e.target.value }))
                }
              />
              {mutualConditionsError && (
                <p className="text-danger text-fz-small mt-1 mb-0">{mutualConditionsError}</p>
              )}
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default SectionMutualRecruiting;
